const E = {
  Save: 'Save',
  'No Email Notifcations': 'No Email Notifcations',
  Company: 'Company',
  'Report To': 'Report To',
  Attention: 'Attention',
  Project: 'Project',
  Site: 'Site',
  'Job Received': 'Job Received',
  'Job Reported': 'Job Reported',
  Exceedance: 'Exceedance',
  Off: 'Off',
  'On - All Jobs': 'On - All Jobs',
  'On - Jobs Sent To': 'On - Jobs Sent To',
  Error0: 'Preference Fields must include email addresses',
  Scenario: 'Scenario',
  Notification: 'Notification',
  Preference: 'Preference',
};

const F = {
  Site: 'Emplacement du site',
  Preference: 'Préférence',
  Scenario: 'Scénario',
  Notification: 'Notification',
  Save: 'Enregistrer',
  'No Email Notifcations': 'Aucune notification par courriel',
  Company: 'Entreprise',
  'Report To': 'Envoyer rapport à',
  Attention: 'À l’attention de',
  Project: 'Projet',
  'Job Received': 'Dossier reçu',
  'Job Reported': 'Rapport envoyé',
  Exceedance: 'Dépassement',
  Off: 'Annuler',
  'On - All Jobs': 'Au sujet de – Tous les dossiers',
  'On - Jobs Sent To': 'Au sujet de – Dossiers envoyés à',
  Error0: 'Les champs de préférence doivent inclure des adresses électroniques.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/emailNotifications.js